export type { CarouselButtonsProps } from './CarouselButtons/DefaultButtons'
export type { CarouselProps } from './Carousel'
export { default as Carousel } from './Carousel'
